import React from 'react';
import { ListTodoIcon, CheckCircle2Icon, Loader2Icon, XCircleIcon, BanIcon } from 'lucide-react';
import { useScreenInit } from '../useScreenInit';
import { useTaskStore } from '../stores/taskStore';
import { useUiStore } from '../stores/uiStore';
import { PageContainer, PageHeader, EmptyState, TaskStatusBadge } from '../components/common/page';
import { Card, Button } from '../components/common/ui';
import { formatRelative } from '../utils/format';
const typeLabel: Record<string, string> = {
  skill_upload: 'Skill 上传',
  skill_url_install: '第三方安装',
  skill_generate: 'AI 创建 Skill',
  kb_doc_parse: '知识库文档解析',
  kb_chunk: '知识库切片',
  kb_embed: '知识库向量化',
  kb_reindex: '知识库索引重建',
  agent_test: 'Agent 测试',
  agent_run: 'Agent 执行'
};
export function TasksPage() {
  useScreenInit();
  const tasks = useTaskStore(s => s.tasks);
  const cancelTask = useTaskStore(s => s.cancelTask);
  const pushToast = useUiStore(s => s.pushToast);
  return <PageContainer data-id="element-952">
      <PageHeader title="任务面板" description="后台任务列表、进度、日志与取消" data-id="element-953" />

      {tasks.length === 0 ? <EmptyState icon={ListTodoIcon} title="暂无任务" data-id="element-954" /> : <div className="space-y-3" data-id="element-955">
          {tasks.map(t => <Card key={t.taskId} className="p-4" data-id="element-956">
              <div className="flex items-start justify-between gap-3" data-id="element-957">
                <div className="min-w-0" data-id="element-958">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-959">
                    <span className="font-medium text-slate-100" data-id="element-960">
                      {t.title}
                    </span>
                    <TaskStatusBadge status={t.status} data-id="element-961" />
                    <span className="text-xs text-slate-500" data-id="element-962">
                      {typeLabel[t.type] || t.type}
                    </span>
                  </div>
                  <div className="mt-0.5 text-xs text-slate-500" data-id="element-963">
                    更新于 {formatRelative(t.updatedAt)}
                  </div>
                </div>
                {(t.status === 'running' || t.status === 'pending') && <Button variant="ghost" size="sm" onClick={() => {
            cancelTask(t.taskId);
            pushToast('info', '任务已取消');
          }} className="text-red-400 hover:text-red-300" data-id="element-964">
                    <BanIcon className="h-3.5 w-3.5" data-id="element-965" /> 取消
                  </Button>}
              </div>

              <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-slate-800" data-id="element-966">
                <div className={`h-full rounded-full transition-all duration-500 ${t.status === 'failed' ? 'bg-red-500' : t.status === 'completed' ? 'bg-emerald-500' : 'bg-indigo-500'}`} style={{
            width: `${t.progress}%`
          }} data-id="element-967" />
              </div>

              <ul className="mt-3 space-y-1.5" data-id="element-968">
                {t.steps.map((s, i) => <li key={i} className="flex items-center gap-2 text-sm" data-id="element-969">
                    {s.done ? <CheckCircle2Icon className="h-4 w-4 text-emerald-400" data-id="element-970" /> : t.status === 'running' && t.steps.findIndex(x => !x.done) === i ? <Loader2Icon className="h-4 w-4 animate-spin text-indigo-400" data-id="element-971" /> : t.status === 'failed' && t.steps.findIndex(x => !x.done) === i ? <XCircleIcon className="h-4 w-4 text-red-400" data-id="element-972" /> : <span className="h-4 w-4 rounded-full border border-slate-700" data-id="element-973" />}
                    <span className={s.done ? 'text-slate-300' : 'text-slate-500'} data-id="element-974">
                      {s.label}
                    </span>
                  </li>)}
              </ul>

              {t.error && <div className="mt-3 rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-300" data-id="element-975">
                  失败原因：{t.error}
                </div>}
            </Card>)}
        </div>}
    </PageContainer>;
}